<template functional>
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M13.897 2.49413C13.2648 2.29444 12.5925 2.18525 11.8943 2.18525C9.85706 2.18525 8.03393 3.10615 6.81851 4.55288L9.95044 7.18772L13.897 2.49413Z"
      fill="#1A73E8"
    />
    <path
      d="M6.81707 4.55288C5.84876 5.70508 5.26404 7.19203 5.26404 8.81403C5.26404 10.0611 5.51258 11.071 5.92059 11.9761L9.94901 7.18772L6.81707 4.55288Z"
      fill="#EA4335"
    />
    <path
      d="M11.8943 6.27975C13.295 6.27975 14.43 7.41472 14.43 8.81547C14.43 9.43898 14.2044 10.0108 13.8309 10.4518C13.8309 10.4518 15.8336 8.06984 17.7774 5.75968C16.9743 4.21526 15.5822 3.02714 13.8984 2.49413L9.94901 7.18772C10.4145 6.63173 11.1127 6.27975 11.8943 6.27975Z"
      fill="#4285F4"
    />
    <path
      d="M11.8943 11.3497C10.4935 11.3497 9.35854 10.2148 9.35854 8.81403C9.35854 8.19483 9.58122 7.62734 9.94901 7.18629L5.92059 11.9761C6.60876 13.5033 7.75378 14.7288 8.93328 16.2732L13.8294 10.4518C13.3654 11.0006 12.6701 11.3497 11.8943 11.3497Z"
      fill="#FBBC04"
    />
    <path
      d="M13.7332 17.8622C15.9442 14.4041 18.523 12.8338 18.523 8.81403C18.523 7.71211 18.2529 6.6734 17.7774 5.75968L8.93472 16.2732C9.30969 16.7645 9.68753 17.2875 10.0568 17.8636C11.4015 19.941 11.0279 21.1866 11.8957 21.1866C12.7606 21.1866 12.3885 19.9396 13.7332 17.8622Z"
      fill="#34A853"
    />
  </svg>
</template>

<script>
export default {
  name: "GoogleMapsIcon"
};
</script>
